import PolymerAxisView, {PolymerAxisViewOptions} from 'molbio/maps/linear/PolymerAxisView';
import Type from 'molbio/maps/Type';
import ProteinAlignmentTabState from 'molbio/tabstates/ProteinAlignmentTabState';
import * as vo from 'settings/visibility-options/VisibilityOptions';

interface ProteinAlignmentAxisViewOptions extends PolymerAxisViewOptions {
  tabstate: ProteinAlignmentTabState;
}

class ProteinAlignmentAxisView extends PolymerAxisView {
  tabstate!: ProteinAlignmentTabState;

  static initClass(): void {
    this.prototype.className = 'proteinAlignmentAxis';
    this.prototype.setting = vo.PROTEIN_AXIS.name;
  }

  initialize(options: ProteinAlignmentAxisViewOptions): void {
    super.initialize(options);
    this.tabstate = options.tabstate;
  }

  getStartIndex(): number {
    return 1;
  }

  getBasesType(): Type {
    return this.tabstate.getType();
  }

  getPolymerLength(): number {
    return this.tabstate.getPolymerLength();
  }
}

ProteinAlignmentAxisView.initClass();

export default ProteinAlignmentAxisView;
